import axios from 'axios';

import type Rollbar from 'rollbar';

export async function logout(rollbar: Rollbar) {
  try {
    const res = await axios.get(`/api/logout/`, {
      withCredentials: true,
    });
    return { logged: false, status: res?.status };
  } catch (error: unknown) {
    rollbar.error('Error logging out', error as Rollbar.LogArgument);
  }
}
